import { render, staticRenderFns } from "./SecondReviewerForm.vue?vue&type=template&id=312ee728"
import script from "./SecondReviewerForm.vue?vue&type=script&lang=js"
export * from "./SecondReviewerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports